import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'

   export const getData = createAsyncThunk('providerSettings/getData', async (params) => {
 
      const response = await axios.post(' https://api.zasway.com:8443/ProviderSettings/GetTableSummary', params, {mode:'cors'})
 
      return {
         params,
         data: response.data
      }
   })

   export const getProvider = createAsyncThunk('providerSettings/getProvider', async (params) => {
       
      const response = await axios.post(' https://api.zasway.com:8443/ProviderSettings/GetProvider', params, {mode:'cors'})
 
      return {
         params,
         data: response.data
      }
   })

   export const addProviderSettings = createAsyncThunk('providerSettings/addProviderSettings', async (Provider) => {
       
      const response = await axios.post(' https://api.zasway.com:8443/ProviderSettings/Create', Provider, {mode:'cors'})
         return response
   })

   export const editProviderSettings  = createAsyncThunk('providerSettings/editProviderSettings', async (Edit) => {
 
      const response = await axios.post(' https://api.zasway.com:8443/ProviderSettings/Update', Edit, {mode:'cors'})
         return response
   })

export const providerSettingsSlice = createSlice({
   name: 'providerSettings',
   initialState: {
      ProviderSettingsEditData: [],
      ProviderUserData: [],
      ProviderEditData: []
   },
     reducers: {},
     extraReducers: builder => {
      builder

      .addCase(getData.fulfilled, (state, action) => {
         state.ProviderEditData = action.payload.data
      })
      
      .addCase(getProvider.fulfilled, (state, action) => {
          
         state.ProviderUserData = action.payload.data
      })

      .addCase(editProviderSettings.fulfilled, (state, action) => {
          
         state.ProviderSettingsEditData = action.payload.data
      })
 
     }
})
   
 export default providerSettingsSlice.reducer